import axios from "axios";

export const REMOTE_BASE_URL = "https://cdn.bosslogics.live";
export const API_URL = process.env.REACT_APP_API_CLIENT_BASE_URL;

export const REACT_APP_PUBLIC_API_KEY = process.env.REACT_APP_DEFAULT_API_KEY;
export const REACT_APP_IDENTITY_SERVER_BASE_URL = process.env.REACT_APP_IDENTITY_SERVER_BASE_URL;
export const REACT_APP_API_CLIENT_BASE_URL = process.env.REACT_APP_API_CLIENT_BASE_URL;
export const IDENTITY_AUTH_PROXY = process.env.REACT_APP_IDENTITY_AUTH_PROXY;
export const FONT_SERVER = process.env.REACT_APP_FONT_SERVER;
export const PAGE_TITLE_SUFFIX = " | BOSS Logics Live Catalog";

export const AxiosClient = axios.create({
	baseURL: "/",
});

const APItoken =
	"auto-generated-api-token-from-identity-proxy-server-overridden-using-axios-interceptor";

export const CATALOG_SEARCH_PATHS = {
	id: true,
	label: true,
	title: true,
	initial_uri: true,
	uri: true,
	slug: true,
	options: true,
	account: {
		id: true,
		name: true,
		code: true,
	}
};
export const CATALOG_PATHS = {
	id: true,
	label: true,
	title: true,
	initial_uri: true,
	uri: true,
	slug: true,
	options: true,
	pages: {
		id: true,
		label: true,
		uri: true,
		alias_slug: true,
		link: true,
		slug: true,
		rank: true,
		parent: true,
		module_set: true,
		type: {
			code: true,
		},
		public: true,
		icon: true,
		title: true,
		options: true,
		heading: true,
		subheading: true,
		copy: true,
		hidden: true,
		status: true
	},
	account: {
		id: true,
		name: true,
		code: true,
	},
	thumb_fieldset: {
		id: true,
		handle: true,
		fields: {
			id: true,
			options: true,
			common: {
				id: true,
				label: true,
				options: true
			}
		}
	},
	detail_fieldset: {
		id: true,
		handle: true,
		fields: {
			id: true,
			options: true,
			common: {
				id: true,
				label: true,
				options: true
			}
		}
	},
	footer: true
};

export const AxiosAPIClient = axios.create({
	baseURL: process.env.REACT_APP_API_CLIENT_BASE_URL || "https://staging.bosslogics.live/api",
	headers: {
		Authorization: APItoken || "",
		Project: "together.boss",
		Accept: "application/json",
		'Cache-Control': 'no-cache',
		'Pragma': 'no-cache',
		'Expires': '0',
	},
	// params : { timestamp: Date.now() }
});

//temporary upload_key for uploading images
const upload_key = encodeURIComponent("HTE*z$iI$P)mnpmcV9ZkPRZOGQ&LrVbP-(JciYFjIJNow)3Y4f");
export const AxiosImageAPIClient = axios.create({
	// baseURL: "https://cdn.bosslogics.live/controllers/upload.php?__upload_key=" + upload_key,
	baseURL: "https://cdn.bosslogics.live/controllers/upload.php",


});

export const AxiosAuthClient = axios.create({
	baseURL: IDENTITY_AUTH_PROXY || (window.location.protocol + "//" + window.location.host + "/identity"),
	headers: {
		"Content-Type": "application/x-www-form-urlencoded",
		Accept: "application/json",
	},
});


const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const winConfig = window._bossLiveConfig || {};

const getConfigValue = key => {
	const value = winConfig[key]
		|| urlParams.get(key)
		|| localStorage.getItem('rebase.' + key)
		|| "";
	value && localStorage.setItem('rebase.' + key, value);
	return value;
};

export const BASE_PATH = getConfigValue('basePath');
export const DOM_ROOT_ID = getConfigValue('domRootId');
export const X_API_KEY = getConfigValue('xApiKey');
export const STATIC_CATALOG = winConfig.catalog;
export const SINGLE_PAGE = winConfig['singlePage'];

export const DEFAULT_BG_COLOR = "#E2E8F0";
export const DEFAULT_FG_COLOR = "#FFFFFF";
export const DEFAULT_THEME_TEMPLATE = {
	themes: {
		header: {
			foreground:{
				color: DEFAULT_FG_COLOR
			},
			background: {
				color: DEFAULT_BG_COLOR
			}
		}
	}
}